import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, LayoutGrid, Database, DockIcon, Smartphone, Headphones, MessageCircle, Phone, Facebook, Linkedin, Mail, MapPin, Check, Crown, Star, TrendingUp, Package, Info } from "lucide-react";
import './LandingPage.css';
import nobg from "../assets/images/noBG logo.png";

export default function LandingPage() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    // const logoUrl = "https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/render/image/public/document-uploads/favicon-1767191052054.jpg?width=800&height=800&resize=contain";

    const features = [
        {
            title: "حماية كاملة",
            description: "تأمين كامل لبياناتك لضمان عدم تسريبها.",
            icon: Shield,
        },
        {
            title: "إدارة مستودعات متعددة",
            description: "نظامنا يسمح لك بإدارة مستودع واحد أو أكثر من مستودع بنفس الكفاءة والسهولة.",
            icon: LayoutGrid,
        },
        {
            title: "منع فقدان البيانات",
            description: "نضمن لك عدم فقدان أي معلومة بفضل تقنيات النسخ الاحتياطي السحابي الفوري.",
            icon: Database,
        },
        {
            title: "تقارير دورية",
            description: "نوفر لك تقارير يومية وشهرية لجميع الحركات التي تمت داخل المخزن.",
            icon: DockIcon,
        },
        {
            title: "واجهة سهلة الاستخدام",
            description: "تصميم عصري وبسيط يسهل على الموظفين التعامل مع النظام دون الحاجة لتدريب طويل.",
            icon: Smartphone,
        },
        {
            title: "دعم فني متواصل",
            description: "فريقنا معك دائماً لحل أي مشكلة تقنية تواجهك وضمان استمرارية عملك.",
            icon: Headphones,
        },
    ];

    return (
        <div className="landing-root">
            {/* Navbar */}
            <nav className="landing-nav">
                <div className="landing-container nav-container">
                    <img src={nobg} alt="أمانك - Amanak" className="navbar-logo-img" />

                    <button className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                        ☰
                    </button>

                    <div className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
                        <div className="landing-nav-links">
                            <Link to="/about-us" className="nav-link-btn" onClick={() => setMobileMenuOpen(false)}>من نحن</Link>
                            <Link to="/privacy-policy" className="nav-link-btn" onClick={() => setMobileMenuOpen(false)}>سياسة الخصوصية</Link>
                            <Link to="/terms-and-conditions" className="nav-link-btn" onClick={() => setMobileMenuOpen(false)}>الشروط والأحكام</Link>
                            <a href="#contact" className="nav-link-btn" onClick={() => setMobileMenuOpen(false)}>اتصل بنا</a>
                        </div>
                        <Link to="/home" className="nav-cta-btn">دخول للنظام</Link>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <header id="hero" className="hero-section">
                <div className="landing-container hero-container">
                    <div className="hero-content">
                        <h1 className="hero-title">أمانك.. دقة في الجرد<br /> وثقة في الإدارة</h1>
                        <p className="hero-subtitle">
                            أمانك نظام ERP ( نظام تخطيط موارد المؤسسة ) يتيح لك تسجيل وحفظ جميع معاملاتك وحركة المخزون لضمان تقارير دقيقة وتتبع كامل للمخزون والكميات المتوفرة في اي وقت ومكان.                                                   </p>
                        <div className="hero-actions">
                            <Link to="/home" className="hero-cta-btn primary">ابدأ الآن</Link>
                            <a href="#features" className="hero-cta-btn secondary">تعرف على المزيد</a>
                        </div>
                    </div>
                </div>
            </header>

            {/* Product Section */}
            <section id="product" className="product-section">
                <div className="landing-container">
                    <div className="section-header">
                        <h2 className="section-title">نظام إدارة المخازن الأكثر أماناً وموثوقية</h2>
                        <p className="section-subtitle">
                            نحن نقدم لك نظام كامل متكامل يجمع بين القوة البرمجية وسهولة الإستخدام مع التركيز المطلق على أمان البيانات
                        </p>
                    </div>

                    <div className="product-grid">
                        <div className="product-card">
                            <h3>رقابة كاملة</h3>
                            <p>تسجيل وتتبع كامل لجميع حركات المخزون سواء وارد، منصرف او إنتاج مع تقارير دورية.</p>
                        </div>
                        <div className="product-card">
                            <h3>تسجيل المعاملات</h3>
                            <p>يتم حفظ جميع البيانات الخاصة بالمعاملة واسم الموظف الذي اجرى المعاملة.</p>
                        </div>
                        <div className="product-card">
                            <h3>رؤية شاملة</h3>
                            <p>مع تطبيقنا الإضافي احصل على رؤية شاملة لمخازنك في أي لحظة ومن أي مكان.</p>
                        </div>
                        <div className="product-card">
                            <h3>إدارة الصلاحيات</h3>
                            <p>إدارة صلاحيات الموظفين وتتبع نشاطهم بدقة متناهية.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section id="features" className="features-section">
                <div className="landing-container">
                    <h2 className="section-title">لماذا تختار أمانك؟</h2>
                    <p className="section-subtitle">نحن نقدم حلولاً تقنية تجمع بين القوة البرمجية وسهولة الاستخدام مع التركيز المطلق على أمن المخزن.</p>

                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <FeatureCard
                                key={index}
                                Icon={feature.icon}
                                title={feature.title}
                                desc={feature.description}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Pricing Section */}
            <section id="pricing" className="pricing-section">
                <div className="landing-container">
                    <div className="section-header">
                        <h2 className="section-title">أختر الباقة اللتي تناسب استخدامك</h2>
                        <p className="section-subtitle">
                            نوفر باقات مختلفة تناسب جميع الاحتياجات سواء محلات صغيرة او مخازن كبيرة او حتى مجموعات من المخازن
                        </p>
                    </div>

                    <div className="pricing-grid">
                        {/* Plan 3 - Sales */}
                        <div className="pricing-card">
                            <div className="pricing-card-header">
                                <div className="pricing-icon-wrapper">
                                    <TrendingUp size={28} />
                                </div>
                                <h3 className="pricing-plan-name">نظام المبيعات</h3>
                                <p className="pricing-plan-desc">الحل الأمثل لإدارة المبيعات وتتبعها بكفاءة</p>
                            </div>
                            <div className="pricing-price-wrapper">
                                <span className="pricing-amount">$100</span>
                                <span className="pricing-currency">شهرياً</span>
                            </div>
                            <ul className="pricing-features">
                                <li><Check size={18} className="pricing-check" /> نظام مبيعات متكامل</li>
                                <li><Check size={18} className="pricing-check" /> 2 مستخدمين</li>
                                <li><Check size={18} className="pricing-check" /> تقارير يومية</li>
                                <li><Check size={18} className="pricing-check" /> تقارير شهرية</li>
                                <li><Check size={18} className="pricing-check   " /> دعم فني متواصل مجاناً</li>
                            </ul>
                            <div className="pricing-trial-badge">
                                <Star size={14} />
                                تجربة مجانية لمدة شهر
                            </div>
                            <a href="https://wa.me/249127105555" target="_blank" rel="noopener noreferrer" className="pricing-cta-btn">ابدأ تجربتك المجانية</a>
                        </div>

                        {/* Plan 1 - Warehouses */}
                        <div className="pricing-card">
                            <div className="pricing-card-header">
                                <div className="pricing-icon-wrapper">
                                    <Package size={28} />
                                </div>
                                <h3 className="pricing-plan-name">نظام المخازن</h3>
                                <p className="pricing-plan-desc">إدارة مخازنك بكفاءة مع تطبيق مراقبة للمالك</p>
                            </div>
                            <div className="pricing-price-wrapper">
                                <span className="pricing-amount">$105</span>
                                <span className="pricing-currency">شهرياً</span>
                            </div>
                            <ul className="pricing-features">
                                <li><Check size={18} className="pricing-check" /> نظام مخازن متكامل</li>
                                <li><Check size={18} className="pricing-check" /> 3 مستخدمين</li>
                                <li><Check size={18} className="pricing-check" /> تقارير يومية</li>
                                <li><Check size={18} className="pricing-check" /> تقارير شهرية</li>
                                <li><Check size={18} className="pricing-check" /> تطبيق مراقبة للمالك</li>
                                <li><Check size={18} className="pricing-check" /> دعم فني متواصل مجاناً</li>
                            </ul>
                            <div className="pricing-trial-badge">
                                <Star size={14} />
                                تجربة مجانية لمدة شهر
                            </div>
                            <a href="https://wa.me/249127105555" target="_blank" rel="noopener noreferrer" className="pricing-cta-btn">ابدأ تجربتك المجانية</a>
                        </div>

                        {/* Plan 2 - Warehouses + Production */}
                        <div className="pricing-card">
                            <div className="pricing-card-header">
                                <div className="pricing-icon-wrapper">
                                    <LayoutGrid size={28} />
                                </div>
                                <h3 className="pricing-plan-name">المخازن + الإنتاج</h3>
                                <p className="pricing-plan-desc">نظام مخازن مع نظام الإنتاج وتطبيق مراقبة للمالك</p>
                            </div>
                            <div className="pricing-price-wrapper">
                                <span className="pricing-amount">$120</span>
                                <span className="pricing-currency">شهرياً</span>
                            </div>
                            <ul className="pricing-features">
                                <li><Check size={18} className="pricing-check" /> نظام مخازن متكامل</li>
                                <li><Check size={18} className="pricing-check" /> نظام إنتاج متكامل</li>
                                <li><Check size={18} className="pricing-check" /> 4 مستخدمين</li>
                                <li><Check size={18} className="pricing-check" /> تقارير يومية</li>
                                <li><Check size={18} className="pricing-check" /> تقارير شهرية</li>
                                <li><Check size={18} className="pricing-check" /> تطبيق مراقبة للمالك</li>
                                <li><Check size={18} className="pricing-check" /> دعم فني متواصل مجاناً</li>
                            </ul>
                            <div className="pricing-trial-badge">
                                <Star size={14} />
                                تجربة مجانية لمدة شهر
                            </div>
                            <a href="https://wa.me/249127105555" target="_blank" rel="noopener noreferrer" className="pricing-cta-btn">ابدأ تجربتك المجانية</a>
                        </div>

                        {/* Plan 4 - Full System (Popular) */}
                        <div className="pricing-card pricing-card-popular">
                            <div className="pricing-popular-badge">
                                <Crown size={14} />
                                الأكثر طلباً
                            </div>
                            <div className="pricing-card-header">
                                <div className="pricing-icon-wrapper pricing-icon-popular">
                                    <Crown size={28} />
                                </div>
                                <h3 className="pricing-plan-name">النظام الكامل</h3>
                                <p className="pricing-plan-desc">مخازن + إنتاج + مبيعات + تطبيق مراقبة لمالك المخزن</p>
                            </div>
                            <div className="pricing-price-wrapper">
                                <span className="pricing-amount pricing-amount-popular">$150</span>
                                <span className="pricing-currency">شهرياً</span>
                            </div>
                            <ul className="pricing-features">
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> نظام مخازن متكامل</li>
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> نظام إنتاج متكامل</li>
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> نظام مبيعات متكامل</li>
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> تطبيق مراقبة لمالك المخزن</li>
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> 5 مستخدمين</li>
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> تقارير يومية</li>
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> تقارير شهرية</li>
                                <li><Check size={18} className="pricing-check pricing-check-popular" /> دعم فني متواصل مجاناً</li>
                            </ul>
                            <div className="pricing-trial-badge pricing-trial-popular">
                                <Star size={14} />
                                تجربة مجانية لمدة شهر
                            </div>
                            <a href="https://wa.me/249127105555" target="_blank" rel="noopener noreferrer" className="pricing-cta-btn pricing-cta-popular">ابدأ تجربتك المجانية</a>
                        </div>
                    </div>

                </div>
            </section>

            {/* Footer */}
            <footer id="contact" className="landing-footer">
                <div className="landing-container footer-grid">
                    {/* Brand & Social */}
                    <div className="footer-col brand-col">
                        <div className="footer-logo-wrapper">
                            <img src={nobg} alt="أمانك - Amanak" className="footer-logo-img" />
                        </div>
                        <p className="footer-desc">
                            أمانك هي شريكك التقني الموثوق لإدارة ومتابعة مستودعاتك بدقة متناهية و كفاءة وإحترافية.
                        </p>
                        <div className="social-links">
                            {/* <a href="https://twitter.com/" className="social-btn"><Twitter size={20} /></a> */}
                            <a href="https://web.facebook.com/profile.php?id=61586860653173" className="social-btn"><Facebook size={20} /></a>
                            <a href="https://www.linkedin.com/company/amanak/" className="social-btn"><Linkedin size={20} /></a>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-col">
                        <h3 className="footer-heading">تواصل معنا</h3>
                        <ul className="contact-list">
                            <li>
                                <div className="contact-icon"><Phone size={20} /></div>
                                <div>
                                    <div className="contact-label">اتصل بنا</div>
                                    <a href="tel:+249127105555" className="contact-value" dir="ltr">+249127105555</a>
                                </div>
                            </li>
                            <li>
                                <div className="contact-icon"><MessageCircle size={20} /></div>
                                <div>
                                    <div className="contact-label">واتساب</div>
                                    <a href="https://wa.me/249127105555" target="_blank" rel="noopener noreferrer" className="contact-value">راسلنا مباشرة</a>
                                </div>
                            </li>
                            <li>
                                <div className="contact-icon"><Mail size={20} /></div>
                                <div>
                                    <div className="contact-label">البريد الإلكتروني</div>
                                    <a href="mailto:amanakhq@gmail.com" className="contact-value">amanakhq@gmail.com</a>
                                </div>
                            </li>
                        </ul>
                    </div>

                    {/* Location */}
                    <div className="footer-col">
                        <h3 className="footer-heading">حول</h3>
                        <div className="location-wrapper">
                            <div className="contact-icon location-icon"><MapPin size={20} /></div>
                            <p className="location-text">
                                السودان<br />
                                الخرطوم - امدرمان
                            </p>
                        </div>
                        <Link to="/about-us" className="footer-about-link">
                            <div className="contact-icon location-icon"><Info size={20} /></div>
                            من نحن
                        </Link>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>© {new Date().getFullYear()} أمانك (Amanak). جميع الحقوق محفوظة.</p>
                    <div className="footer-legal">
                        <Link to="/privacy-policy">سياسة الخصوصية</Link>
                        <Link to="/terms-and-conditions">الشروط والأحكام</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}

function FeatureCard({ Icon, title, desc }) {
    return (
        <div className="feature-card">
            <div className="feature-icon-wrapper">
                <Icon className="feature-icon" strokeWidth={1.5} />
            </div>
            <div className="feature-content">
                <h3 className="feature-title">{title}</h3>
                <p className="feature-desc">{desc}</p>
            </div>
        </div>
    );
}
